export const openBookingModal = () => window.dispatchEvent(new CustomEvent("bf-open-booking"));
